import axios from "@/util/request.js"

//账号登录接口
export function onSubmit(params) {
    return axios.service({
        url: 'users/login',
        method: 'post',
        params: params
    });
}
//账号登录接口（新11.26）
export function newOnSubmit(params) {
    return axios.service({
        url: '/users/v2/login',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data;'
        }
    });
}
//获取登录框验证码
export function newGetLoginBoxSms(params) {
    return axios.service({
        url: '/users/v2/getLoginSms',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data;'
        }
    });
}

//获取短信验证码
export function getLoginBoxSms(params) {
    return axios.service({
        url: 'users/getLoginSms',
        method: 'post',
        params: params
    });
}
//密码补充接口
export function repairPassword(params) {
    return axios.service({
        url: '/users/repairPassword',
        method: 'post',
        params: params
    });
}
//修改密码接口
export function editPwd(params) {
    return axios.service({
        url: '/users/editPwd',
        method: 'post',
        params: params
    });
}
//短信验证码登录
export function phoneLoginBox(params) {
    return axios.service({
        url: '/users/phoneLogin',
        method: 'post',
        params: params
    });
}
//忘记密码 手机号验证 更改密码
export function passWordEdit(params) {
    return axios.service({
        url: 'users/passWordEdit',
        method: 'post',
        params: params
    });
}
//获取公钥
export function getPublicKey(params) {
    return axios.service({
        url: 'users/getPublicKey',
        method: 'get',
        params: params
    });
}